import React from "react";
import PropTypes from "prop-types";

import "./SummaryBar.module.css";

const renderWarning = (warning) => (
  <div className="alert alert-warning">
    <span className="alert-warning__icon" />
    {warning}
  </div>
);

// eslint-disable-next-line react/no-multi-comp
const renderNotification = (notification) => (
  <div className="alert alert-info">{notification}</div>
);

// eslint-disable-next-line react/no-multi-comp
const SummaryBar = ({ title, warning, notification, children }) => (
  <div styleName="outer">
    {title && <h4 styleName="title">{title}</h4>}
    {warning && renderWarning(warning)}
    {notification && renderNotification(notification)}

    <div className="row">
      {children.map((child, i) =>
        React.cloneElement(child, {
          key: i,
          colClassName: children.length === 4 ? "col-md-3" : "col-md-4"
        })
      )}
    </div>
  </div>
);

SummaryBar.propTypes = {
  title: PropTypes.string,
  warning: PropTypes.string,
  children: PropTypes.array,
  notification: PropTypes.string
};

export { SummaryBar };
